import React, { createContext, useContext, useMemo } from 'react';
import { isInterveneAutomationPaused } from '../utils/interveneAutomation';
import { isComposerActive } from '../utils/composerMode';

const InterveneAutomationContext = createContext({
  isAutomationPaused: false,
  isHandlingSession: false,
});

export function InterveneAutomationProvider({ composerMode, children }) {
  const value = useMemo(
    () => ({
      isAutomationPaused: isInterveneAutomationPaused(composerMode),
      isHandlingSession: isComposerActive(composerMode),
    }),
    [composerMode]
  );

  return (
    <InterveneAutomationContext.Provider value={value}>
      {children}
    </InterveneAutomationContext.Provider>
  );
}

export function useInterveneAutomation() {
  return useContext(InterveneAutomationContext);
}

export default InterveneAutomationContext;
